// eslint-disable-next-line no-shadow
enum EEventGroupType {
    Default = 0,
    JobTitle = 1,
}

export default EEventGroupType
